import styles from "../Components/OrderItem.module.css";
const OrderItem = ({items}) => {
    return <>
    {/* <div className="card mb-3"> */}
          <div className="row g-0">
            <div className="col-md-4">              
              <p id={`${styles.rcorners1}`}><img
                      src={`${global.config.live_url}${items.product_image}`}
                      className="card-img-top"
                      alt="..." width="200px" height="150px"
                    /></p>
            </div>
            <div className="col-md-4">
              <div className="card-body">        
                
                <p className="card-text">
                  <small className="text-muted">{items.product_name}</small>
                </p>
                <p className="card-text">
                  <small className="text-muted">{items.product_weight} {items.product_unit}</small>
                </p>
                <p className="card-text">
                  <small className="text-muted">
                    &#x20B9;{" "}
                      {items.product_offer > 0
                        ? Math.round(
                            items.product_price -
                              (items.product_price * items.product_offer) / 100
                          )
                        : ""}{" "}
                      {items.product_offer > 0 ? (
                        <span className={styles.productPriceLineThrough}>
                          &#x20B9;{items.product_price}
                        </span>
                      ) : (
                        items.product_price
                      )}{" "}
                  </small>
                </p>
              </div>
            </div>
            <div className="col-md-4">  
                           
            </div>
          </div>
        {/* </div> */}
    </>

}
export default OrderItem;